export default function scheduleObjToString(schedule, delimiter = ' — ') {
  const todayHours = schedule.today.hours;

  if (process.env.NODE_ENV !== 'production') {
    if (todayHours.length > 1) {
      console.error('Time to change the below code, it only handles days with a single time range');
    }
  }

  if (todayHours.length === 0) {
    return 'Выходной';
  }
  return todayHours[0].split('-').join(delimiter);
}
